import { ActionList, Button, Popover, SkeletonBodyText } from "@shopify/polaris"
import { PopoverOverlayProps } from "@shopify/polaris/build/ts/latest/src/components/Popover/components"
import { IconSource } from "@shopify/polaris/build/ts/latest/src/types"
import classNames from "classnames"
import React, { ReactElement, useCallback, useState } from "react"

import styles from "./index.module.scss"

export type PopoverActionsProps = {
  text?: string
  icon?: IconSource | ReactElement
  plain?: boolean
  monochrome?: boolean
  removeUnderline?: boolean
  customActivator?: boolean
  disclosure?: boolean | "select" | "down" | "up"
  preferredAlignment?: PopoverOverlayProps["preferredAlignment"]
  fullWidth?: boolean
  optsFullWidth?: boolean
  maxHeight?: string
  disabled?: boolean
  loading?: boolean
  customCss?: boolean
  textAlign?: "left" | "center" | "right" | "start" | "end" | undefined
  poupActive?: boolean
  fixed?: boolean
  primary?: boolean
  onPopoverClose?: () => void
  items: {
    disabled?: boolean
    destructive?: boolean
    content: string | React.ReactElement
    action: () => void
    onAction?: () => void
  }[]
}

const PopoverActions = (props: PopoverActionsProps) => {
  const {
    text,
    icon,
    plain,
    items = [],
    preferredAlignment,
    removeUnderline = false,
    monochrome = false,
    disclosure,
    fullWidth = false,
    textAlign,
    customActivator = false,
    optsFullWidth = false,
    maxHeight,
    disabled = false,
    loading = false,
    customCss = false,
    poupActive,
    fixed = false,
    primary = false,
    onPopoverClose,
  } = props

  const [active, setActive] = useState(poupActive || false)

  const openPopover = useCallback(() => setActive(true), [])

  const closePopover = useCallback(() => {
    setActive(false)
    onPopoverClose?.()
  }, [onPopoverClose])

  const toggleActive = useCallback(() => {
    setActive((prev) => {
      if (prev) onPopoverClose?.()
      return !prev
    })
  }, [onPopoverClose])

  items.forEach((action) => {
    action.onAction = () => {
      // 禁用点击
      if (action.disabled) return false
      // 注入关闭popover函数
      toggleActive()
      action.action()
    }
  })

  return (
    <Popover
      active={active}
      fixed={fixed}
      activator={
        customActivator ? (
          <div className="cursor-pointer" onClick={openPopover}>
            {loading ? <SkeletonBodyText lines={1} /> : icon}
          </div>
        ) : (
          <Button
            id="lang-btn"
            loading={loading}
            disabled={disabled}
            onClick={openPopover}
            textAlign={textAlign}
            fullWidth={fullWidth}
            variant={
              primary
                ? "primary"
                : monochrome && plain
                  ? "monochromePlain"
                  : plain
                    ? "plain"
                    : undefined
            }
            // monochrome={monochrome}
            removeUnderline={removeUnderline}
            disclosure={disclosure}
            icon={icon}
          >
            {text}
          </Button>
        )
      }
      autofocusTarget="first-node"
      fullWidth={optsFullWidth}
      onClose={closePopover}
      preferredAlignment={preferredAlignment}
    >
      <div
        className={classNames(
          styles.noActive,
          maxHeight && maxHeight,
          customCss && styles.addBorder,
        )}
        style={{ "--p-space-150": "8px" }}
      >
        <ActionList
          id="lang-action"
          actionRole="menuitem"
          // @ts-ignore
          items={items}
        />
      </div>
    </Popover>
  )
}

export default PopoverActions
